function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeWidth: 0.888
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.19 25.578h34.583v29.286H10.19z",
  strokeWidth: 1.0002432
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.406 33.462h12.15v21.402h-12.15zM27.482 1.923C24.002 4.88 5.517 25.578 5.517 25.578h43.93S30.96 4.88 27.482 1.923z",
  strokeWidth: 1.0002432
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.62 5.866v6.652c1.138 1.24 2.094 2.266 3.203 3.485h.176V5.866z",
  strokeWidth: 1.0002432
}));

var SvgHouse = function SvgHouse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/House.c9b57a2d.svg";
export { ForwardRef as ReactComponent };